import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./public/core/routing/public.routes').then(c => c.PUBLIC_ROUTES)
  },
  {
    path: 'administration',
    loadChildren: () => import('./administration/core/routing/administration.routes').then(c => c.ADMINISTRATION_ROUTES)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
